import React from 'react';

const MainLayout = ({ children, addClass = "" }) => {
    return (
        <div className={`main-layout ${addClass}`}>
            {children}
        </div>
    );
};

export default MainLayout;
